<section class="not-found-container">
    <mat-card appearance="outlined">
        <h3 style="color: orange">404</h3>
        <img src="/assets/images/icon_404.png" />
        <h2>Este link no tiene poder aquí</h2>

        <button
            atom-button="primary"
            (click)="goToChat()"
        >
            <mat-icon>home</mat-icon> Volver al chat
        </button>
    </mat-card>
</section>
